<template>
  <div class="login-rect container win-drag-bar">
    <div class="login-show">
      <a class="logo-cloud login-logo" target="_blank" href="https://cloud.tencent.com">{{$t('core.TencentCloud')}}</a>
      <a class="logo login-logo" ref="logo" target="_blank" href="https://cloud.tencent.com/document/product/436/11366">
        COSBrowser
      </a>
    </div>
    <div class="login-form">
      <div class="logo login-logo hide"></div>

      <div class="login-form-container no-drag-bar">
        <h2 class="login-form__title">
          {{$t('core.key_login')}}
        </h2>

        <!-- key login start -->
        <div>
          <ul class="cos-form__list">
            <li class="cos-form__item">
              <div class="cos-form__label">SecretID</div>
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.secret_id')"
                v-model.trim="SecretId" @keyup="Remark='';Remember=false">
            </li>
            <li class="cos-form__item">
              <div class="cos-form__label">SecretKey</div>
              <input type="password" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.secret_key')"
                v-model.trim="SecretKey">
            </li>
            <li class="cos-form__item">
              <div class="cos-form__label">
                {{`${$t('cos.bucket[0]')}/${$t('cos.access_path[0]')}`}}
                <qc-bubble :append-to-body="false" trigger="hover" placement="top" type="dark"
                  class="custom-login-bubble">
                  <i class="sk-login_pathic"></i>
                  <template slot="popup">{{$t('cos.tips.whether_to_enter_access_path')}}</template>
                </qc-bubble>
              </div>
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.add_path')"
                v-model.trim="AccessPath" @change="checkAccessChange">
            </li>
            <li class="cos-form__item cos-form-area" v-if="AccessPath">
              <div class="cos-form__label ">{{$t('cos.region_name')}}</div>
              <div class="cos-form__select-list">
                <qc-autocomplete :placeholder="$t('cos.placeholder.region')" v-model.trim="Region" trigger="focus"
                  :options="regionList" class="full-width"></qc-autocomplete>
              </div>
            </li>
            <li class="cos-form__item">
              <div class="cos-form__label">{{$t('core.remark')}}</div>
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.add_remark')"
                v-model.trim="Remark">
            </li>
            <li class="cos-form__item">
              <p class="mt-20">
                <label class="form-ctrl-label">
                  <input type="checkbox" class="tc-15-checkbox" v-model="Remember">{{$t('cos.remember_session')}}
                </label>
                <label class="pull-right">
                  <a v-if="oauthLoading" href="javascript:;">
                    <qc-icon type="loading"></qc-icon>
                  </a>
                  <a v-else href="javascript:void(0)" @click="onQcloudLogin">{{$t('cos.oauth_login')}}</a>
                </label>
              </p>
            </li>
          </ul>
        </div>
        <!-- key login end -->

        <button type="button" class="tc-15-btn full-width login-btn" @click="loginUser">{{$t('core.login')}}</button>

        <div class="mt-20 text-center">
          <a :href="loginCamUrl" class="login-operate"
            target="_blank">{{$t('cos.get_secret_key')}}</a>
          <router-link to="/history" replace class="login-operate">{{$t('cos.history_session')}}</router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import adCorner from '@/components//common/adCorner';
import dialog from '@/scripts/tools/dialog';
import { tips } from '@/scripts/tools/utils';
import user from '@/scripts/helper/user';
import menu from '@/scripts/helper/menu';
import keyBox from '@/scripts/helper/keyBox';
import { regions } from '@/scripts/tools/config';
import oauth from '@/scripts/helper/oauth';
import storage from '@/scripts/tools/storage';
import eventProxy from '@/scripts/tools/eventProxy';

export default {
  components: {
    // adCorner,
  },
  data() {
    return {
      SecretId: '',
      SecretKey: '',
      AccessPath: '',
      Region: '',
      Remark: '',
      Remember: false, // 记住会话

      regionList: [],
      showQcloudLogin: false, // 打开 oauth 登录弹窗
      oauthLoading: false, // 显示 oauth 网址加载中
      showRefreshQcloudLogin: false, // 显示刷新 oauth 登录的按钮
      webview: {},
      loginCamUrl: `https://${this.$store.consoleDomain}/cam/capi`,
    };
  },
  mounted() {
    storage.del('userInfo');
    this.initData();
    this.handleRegionList();
    eventProxy.on('OPEN_OAUTH_LOGIN', this.onQcloudLogin);
  },
  destroyed() {
    eventProxy.off('OPEN_OAUTH_LOGIN', this.onQcloudLogin);
  },
  methods: {
    async initData() {
      const info = await keyBox.getLastSession();
      if (info) {
        this.changeInfo(info);
      }
    },
    handleRegionList() {
      const language = this.$store.localeLanguage;
      const regionList = regions.filter(v => !v.hidden);
      this.regionList = regionList.map(item => {
        let label = '';
        if (language === 'zh') {
          const labelLan = `label_${language}`;
          label = `(${item[labelLan]})`;
        }
        return {
          label: item.region + label,
          value: item.region,
        };
      });
    },
    changeInfo(info) {
      this.SecretId = info.SecretId;
      this.SecretKey = info.SecretKey;
      this.AccessPath = info.AccessPath;
      this.Region = info.Region;
      this.Remark = info.Remark;
      this.Remember = info.Remember;
    },
    checkAccessChange() {
      if (!this.AccessPath) {
        this.Region = '';
      }
      this.AccessPath = this.AccessPath.replace(/\/*$/, '/')
        .replace(/^\/+/, '')
        .replace(/\/{2,}/, '/');
    },
    checkRemember() {
      return new Promise(resolve => {
        const existSession = keyBox.sessionIsExist(this.SecretId);
        if (!this.Remember && !this.AccessPath && existSession) {
          const message = this.$t('cos.confirm.check_remember');
          dialog.confirm({ message }, confirm => {
            if (confirm) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        } else {
          resolve(true);
        }
      });
    },
    validate() {
      let allow = true;
      let errMsg = '';
      // 检查基本错误
      if (!this.SecretId) {
        allow = false;
        errMsg = this.$t('cos.validate.secret_id_empty');
      }
      if (!this.SecretKey) {
        allow = false;
        errMsg = this.$t('cos.validate.secret_key_empty');
      }
      // if (this.SecretId.length !== 36) return errMsg = this.$t('cos.validate.secret_id_format');
      // if (!this.SecretId.startsWith('AKID')) return errMsg = this.$t('cos.validate.secret_key_must_start_with_AKID');
      // if (this.SecretKey.length !== 32) return errMsg = this.$t('cos.validate.secret_key_format');

      if (!this.AccessPath) {
        this.Region = '';
      } else if (this.$store.IsQCloudCos) {
        if (this.Region === '') {
          allow = false;
          errMsg = this.$t('cos.validate.region_key_empty');
        } else {
          const { AccessPath } = this;
          const Bucket = AccessPath.substr(0, AccessPath.indexOf('/'));
          if (!Bucket.length) {
            errMsg = this.$t('cos.validate.empty_input_content');
            allow = false;
          } else if (Bucket.length > 50) {
            errMsg = this.$t('cos.validate.bucket_name_length');
            allow = false;
          } else if (!/^[a-zA-Z0-9_-]{1,40}-[0-9]{1,10}$/.test(Bucket)) {
            errMsg = this.$t('cos.validate.bucket_name_char');
            allow = false;
          }
        }
      }

      // FIX: 直接校验 AKID 会导致国际站账号无法登陆，因此去掉该校验
      // // 校验公有云域名的 secretId 是否正确填写
      // if (this.$store.IsQCloudCos && !this.SecretId.startsWith('AKID')) {
      //   errMsg = this.$t('error.secretIdError');
      //   allow = false;
      // }

      if (errMsg) tips.error(errMsg);
      return allow;
    },
    async loginUser() {
      if (!this.validate()) return;

      const confirm = await this.checkRemember();
      if (!confirm) return;
      user.changeLoginMethod('SecretKey');

      const credential = {
        SecretId: this.SecretId,
        SecretKey: this.SecretKey,
        AccessPath: this.AccessPath,
        Region: this.Region,
        Remark: this.Remark,
        Remember: this.Remember,
      };
      user.setCredential(credential);

      const { AccessPath, Region } = this;
      if (AccessPath && Region) {
        user.login({ keyType: 'SecretKey' });
        this.$store.showSideBar = false;
        // this.computeCrumbs(AccessPath, Region);
      } else {
        tips.loading(this.$t('core.loading'));
        menu.getList(data => {
          const result = data.result || {};
          tips.closeTips();

          // 过滤掉子账号登录的报错
          if (result.message) {
            if (
              AccessPath
              && result.message
                === this.$t('error.needAccessPathOrGetServiceAccess')
            ) {
              // console.log('子账号登录,忽略报错信息');
            } else {
              tips.error(result.message);
            }
          }

          if (result.allow) {
            user.login({ keyType: 'SecretKey' });
            // this.computeCrumbs();
          } else {
            user.setCredential(null);
          }
        });
      }
    },
    async onQcloudLogin() {
      if (this.oauthLoading) return;

      this.showRefreshQcloudLogin = false;
      this.oauthLoading = true;
      const url = await oauth.getCloudLoginUrl();
      this.oauthLoading = false;
      if (!url) return;
      this.oauthLoading = true;
      const { clientId, clientCode } = oauth;
      storage.add('oauth_cache', { clientId, clientCode });
      if (this.$route.query.r_path) {
        storage.add('login_path', this.$route.query.r_path, 'session');
      }
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-rect{
  max-width: 1000px;
  max-height:680px;
  min-width: 500px;
  min-height: 620px;
  margin: auto;
  border: 1px solid #DEE1E6;
}
.full-width {
  width: 100%;
}
.custom-login-bubble {
  ::v-deep .tc-15-bubble-inner {
    padding: 8px 12px;
  }
}

// 云账号登录弹窗样式
.qcloud-login__mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  transition: all 0.2s;
  text-align: center;
  white-space: nowrap;
}
.qcloud-login-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  box-shadow: 1px 1.73px 20px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  background-color: #fff;
  -webkit-app-region: no-drag;

  button {
    position: absolute;
    height: 30px !important;
    &.qcloud-login__close {
      right: 20px;
      top: 10px;
    }
    &.qcloud-login__refresh {
      right: 55px;
      top: 10px;
    }
  }

  webview {
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
